import React from 'react'
import ContentLoader from '@adsk/alloy-react-content-loader'
import { AVATAR_SIZES } from '@adsk/alloy-react-avatar/es/constants'
type AvatarSizes = typeof AVATAR_SIZES
export type AvatarSize = AvatarSizes[keyof AvatarSizes]

interface ContentLoaderProps {
	size?: 'xs' | 'sm' | 'md' | 'lg'
}

interface ImageContentLoaderProps {
	size?: AvatarSize
	style?: React.CSSProperties
	viewBox?: string
}

const MAX_WIDTH = '100'
const WIDTH_CONTAINER = '100%'
const TEXT_HEIGHT = '8'
const TEXT_RADIUS = '1'
const INPUT_HEIGHT = '24'
const INPUT_RADIUS = '1'
const IMAGE_RADIUS = '100'

const getWidth = (size?: string): string => {
	switch (size) {
		case 'xs':
			return '15%'
		case 'sm':
			return '25%'
		case 'md':
			return '50%'
		case 'lg':
			return '75%'
		default:
			return '100%'
	}
}
const getImageDimensions = (size?: AvatarSize): string => {
	switch (size) {
		case AVATAR_SIZES.SMALL_16:
			return '16'
		case AVATAR_SIZES.MEDIUM_24:
			return '24'
		case AVATAR_SIZES.MEDIUM_32:
			return '32'
		case AVATAR_SIZES.LARGE_48:
			return '48'
		case AVATAR_SIZES.XLARGE_64:
			return '64'
		case AVATAR_SIZES.XXLARGE_128:
			return '128'
		default:
			return '48'
	}
}
export const LabelContentLoader: React.FC<ContentLoaderProps> = ({
	size,
}: ContentLoaderProps) => {
	return (
		<ContentLoader
			width={MAX_WIDTH}
			height={TEXT_HEIGHT}
			data-testid="labelcontentloader"
			preserveAspectRatio="none"
			style={{ width: WIDTH_CONTAINER }}
		>
			<rect
				height={TEXT_HEIGHT}
				rx={TEXT_RADIUS}
				ry={TEXT_RADIUS}
				width={getWidth(size)}
			/>
		</ContentLoader>
	)
}

export const InputContentLoader: React.FC<ContentLoaderProps> = ({
	size,
}: ContentLoaderProps) => {
	return (
		<ContentLoader
			width={MAX_WIDTH}
			height={INPUT_HEIGHT}
			data-testid="inputcontentloader"
			preserveAspectRatio="none"
			style={{ width: WIDTH_CONTAINER }}
		>
			<rect
				height={INPUT_HEIGHT}
				rx={INPUT_RADIUS}
				ry={INPUT_RADIUS}
				width={getWidth(size)}
			/>
		</ContentLoader>
	)
}

export const ImageContentLoader: React.FC<ImageContentLoaderProps> = ({
	size,
	style,
	viewBox,
}: ImageContentLoaderProps) => {
	return (
		<ContentLoader
			height={getImageDimensions(size)}
			viewBox={
				viewBox ?? `0 0 ${getImageDimensions(size)} ${getImageDimensions(size)}`
			}
			style={{
				...style,
				width: '100%',
			}}
			data-testid="imagecontentloader"
		>
			<rect
				height={getImageDimensions(size)}
				rx={IMAGE_RADIUS}
				ry={IMAGE_RADIUS}
				width={getImageDimensions(size)}
			/>
		</ContentLoader>
	)
}
